<template>
  <el-container>
    <el-main>
      <div class="cateArea">
        <p class="cateStr" @click="clickHome()">首页</p>
        <span class="iconfont icon-31fanhui2 arrow"></span>
        <p class="cateStr" @click="studyClick()">综合学习</p>
        <span class="iconfont icon-31fanhui2 arrow"></span>
        <p class="cateStr" @click="clickCate()">
          {{ detailInfo.categoriesName }}
        </p>
        <span class="iconfont icon-31fanhui2 arrow"></span>
        <p class="cateStr">详情</p>
      </div>
      <p class="headTitle">{{ detailInfo.title }}</p>
      <div class="cateArea">
        <p class="timeStr">{{ timeStr }}</p>
        <div class="sepLine"></div>
        <p v-for="label in tagList" :key="label" class="itemTag">
          {{ label }}
        </p>
      </div>
      <div class="line"></div>
      <div class="mainArea">
        <div v-html="detailInfo.content" class="introduction"></div>
        <div class="subItem">
          <InformationItem
            v-for="infoItem in detailInfo.recommend"
            :key="infoItem.id"
            :item="infoItem"
            v-on:clickItem="clickArticle"
          />
        </div>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import InformationItem from "@/components/InformationItem.vue";
import { getArticleDetail, commitArticleHits } from "../service/api";
export default {
  components: { InformationItem },
  data() {
    return {
      detailInfo: {},
      timeStr: "",
      tagList: [],
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.$parent.showTopBottomView = true;
    this.$parent.showSearch = true;
    let data = this.$route.query;
    if (data.articleID != "") {
      this.getArticleDetailAction(data.articleID);
    }
  },
  methods: {
    //点击文章
    clickArticle(clickItem) {
      const articleID = clickItem.id;
      commitArticleHits(articleID);
      if (clickItem.link && clickItem.link != "") {
        window.open(clickItem.link, "_blank");
      } else {
        this.getArticleDetailAction(articleID);
      }
    },
    //获取分类下资讯
    async getArticleDetailAction(articleID) {
      const res = await getArticleDetail(articleID);
      console.log("res=", res);
      if (res.data.code === 200 && res.data.success) {
        this.detailInfo = res.data.result;
        console.log(
          "this.detailInfo.articleLable=",
          this.detailInfo.articleLable
        );
        if (
          this.detailInfo.articleLable &&
          this.detailInfo.articleLable != ""
        ) {
          this.tagList = this.detailInfo.articleLable
            .split(",")
            .map((item) => item.trim());
        }

        this.calculateTimeDifference(this.detailInfo.createTime);
      } else {
        this.$message({
          message: res.data.message,
          type: "warning",
        });
      }
    },
    clickItem(url) {
      const externalLink = url;
      window.open(externalLink, "_blank");
    },
    //点击资讯分类
    clickCate() {
      this.$router.push({
        path: "/morearticle",
        query: { selectedID: this.detailInfo.categories },
      });
    },
    studyClick() {
      this.$router.push({
        path: "/morearticle",
        query: { selectedID: 0 },
      });
    },
    clickHome() {
      this.$router.replace({
        path: "/",
      });
    },
    //计算时间
    calculateTimeDifference(createTime) {
      const currentTime = new Date();
      const createTimeDate = new Date(createTime);

      const timeDifference = currentTime - createTimeDate;
      const seconds = Math.floor(timeDifference / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);

      if (days > 0) {
        this.timeStr = `${days}天前`;
      } else if (hours > 0) {
        this.timeStr = `${hours}小时前`;
      } else if (minutes > 0) {
        this.timeStr = `${minutes}分钟前`;
      } else {
        this.timeStr = "刚刚";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.el-main {
  background-color: #f3f5f7;
  position: relative;
  padding: 0px 12.5%;
}
.headBack {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.cateListArea {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  //   width: 100%;
  height: 50px;
}
.rightBtnArea {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.cateItem {
  font-size: 18px;
  font-weight: bold;
  margin: 0px 40px 0px 0px;
  padding: 4px 7px;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  text-align: left;
}
.cateItemRight {
  font-size: 18px;
  font-weight: bold;
  margin: 0px 0px 0px 40px;
  padding: 4px 7px;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  text-align: right;
}
.headTitle {
  margin-top: 30px;
  font-size: 48px;
  font-weight: bold;
  color: #000000;
  text-align: left;
  margin-bottom: 0px;
}
.line {
  background-color: #ebebeb;
  height: 1px;
  width: 100%;
  margin-top: 30px;
}
.infoListArea {
  margin-top: 20px;
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  padding: 0px 10px 0px 10px;
}
.cateArea {
  margin-top: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
}
.cateStr {
  font-size: 14px;
  color: #64696f;
  cursor: pointer;
  line-height: 20px;
  margin: 0px 10px;
}
.arrow {
  color: #64696f;
  font-size: 14px !important;
  margin: 0px 10px;
}
.timeStr {
  font-size: 18px;
  color: #64696f;
  margin: 0px 16px 0px 0px;
}
.introduction {
  margin-top: 50px;
  width: 80%;
  margin-bottom: 3rem;
  background-color: #ffffff;
  border-radius: 30px;
  border-style: none;
  padding: 50px;
  margin-bottom: 50px;
  white-space: pre-wrap;
}

.introduction >>> img {
  width: 100%;
  object-fit: fill;
}
.mainArea {
  display: flex;
  flex-direction: row;
  //   align-items: flex-start;
}
.itemTag {
  text-align: center;
  color: #000000;
  font-size: 14px;
  line-height: 14px;
  background-color: #ffffff;
  margin: 0px 12px 0px 0px;
  padding: 4px 6px;
}
.sepLine {
  width: 1px;
  height: 20px;
  background-color: #64696f;
  margin-right: 16px;
}
.subItem {
  margin-top: 30px;
  margin-bottom: 50px;
}
@media screen and (max-width: 768px) {
  .el-main {
    background-color: #f3f5f7;
    position: relative;
    padding: 0px 5%;
  }
  .headBack {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .cateListArea {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    //   width: 100%;
    height: 50px;
  }
  .rightBtnArea {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .cateItem {
    font-size: 18px;
    font-weight: bold;
    margin: 0px 40px 0px 0px;
    padding: 4px 7px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    text-align: left;
  }
  .cateItemRight {
    font-size: 18px;
    font-weight: bold;
    margin: 0px 0px 0px 40px;
    padding: 4px 7px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    text-align: right;
  }
  .headTitle {
    margin-top: 30px;
    font-size: 38px;
    font-weight: bold;
    color: #000000;
    text-align: left;
    margin-bottom: 0px;
  }
  .line {
    background-color: #ebebeb;
    height: 1px;
    width: 100%;
    margin-top: 20px;
  }
  .cateArea {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    text-align: center;
  }
  .cateStr {
    font-size: 14px;
    color: #64696f;
    cursor: pointer;
    line-height: 20px;
    margin: 0px 5px;
  }
  .arrow {
    color: #64696f;
    font-size: 14px !important;
    margin: 0px 5px;
  }
  .timeStr {
    font-size: 18px;
    color: #64696f;
    margin: 0px 16px 0px 0px;
  }
  .introduction {
    margin-top: 20px;
    width: 100%;
    margin-bottom: 3rem;
    background-color: #ffffff;
    border-radius: 30px;
    border-style: none;
    padding: 10px;
    margin-bottom: 20px;
    min-height: 500px;
    box-sizing: border-box;
    // overflow: hidden;
    white-space: pre-wrap;
    overflow-wrap: break-word;
  }

  .mainArea {
    display: flex;
    flex-direction: column;
    //   align-items: flex-start;
  }
  .itemTag {
    text-align: center;
    color: #000000;
    font-size: 14px;
    line-height: 14px;
    background-color: #ffffff;
    margin: 0px 12px 0px 0px;
    padding: 4px 6px;
  }
  .sepLine {
    width: 1px;
    height: 20px;
    background-color: #64696f;
    margin-right: 16px;
  }
  .subItem {
    margin-top: 30px;
    margin-bottom: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>

<style>
.introduction img {
  max-width: 100%; /* 限制图片的最大宽度为其容器的宽度 */
  height: auto; /* 保持图片的纵横比例，防止变形 */
}
</style>
